var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 12.997 14.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.281 -0.95)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.331 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a92c5",
    stroke: "#fff",
    strokeWidth: "0.1px",
    d: "M30.358,60.455a.583.583,0,1,0-.469,1.068,5.275,5.275,0,1,1-4.22,0,.583.583,0,1,0-.47-1.068,6.449,6.449,0,1,0,5.159,0Z",
    transform: "translate(-21.331 -58.746)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6a92c5",
    stroke: "#fff",
    strokeWidth: "0.1px",
    d: "M235.242,6.448a.586.586,0,0,0,.586-.586V.586a.586.586,0,1,0-1.172,0V5.862A.586.586,0,0,0,235.242,6.448Z",
    transform: "translate(-228.794)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d9e6db07.svg";
export { ForwardRef as ReactComponent };